export default function ConcernsSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-cyan-50 to-blue-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              ここがギャップ？だけど大丈夫！！
            </h2>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-10 lg:p-16">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
              移動距離が長くて負担に感じる？偏らないように調整するので大丈夫です
            </h3>

            <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  まごころヘルパーは、逗子市と葉山町をまたいで訪問介護を行っている事業所です。1日の訪問件数は約5～6件で、移動距離が長いことが特徴の一つ。運転に慣れていない方や経験が浅い方は、「大変そうだな」と感じるかもしれません。
                </p>
                <p>
                  しかし、当事業所では負担がなるべく軽くなるように対応するので、ご安心ください。訪問距離がどの職員もほぼ同じになるように調整。職員1人に負担が偏ることがないように管理しています。さらに、訪問件数や勤務時間に応じて、社用車や自家用車の使用もOKです。もちろん、自家用車を使用した場合は、当事業所で交通費を負担します。翌日の訪問スケジュールの確認ができる体制を整えているので、その日に合わせて移動手段を選べることも、負担を軽減できるポイントです。職員一人ひとりが移動に負担を感じず、最大限の力を発揮して利用者さまへのケアに取り組める環境を整えています。
                </p>
              </div>

              <div className="h-[400px] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/8ebb3146665e17ec1340059b244ef7d9.jpg"
                  alt="移動距離への配慮"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
